<template>
    <div class="flex items-center justify-center py-16">
        <div class="card w-full max-w-md p-10 text-center">
            <p class="text-6xl font-extrabold tracking-tight text-indigo-600 dark:text-indigo-400">
                404
            </p>

            <h1 class="mt-4 text-2xl font-bold text-gray-900 dark:text-gray-100">
                Cette page est introuvable
            </h1>
            <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
                Le lien est peut-être cassé ou la page a été déplacée. Vérifiez l'adresse ou repartez d'ici.
            </p>

            <router-link :to="{ name: 'dashboard' }" class="btn-primary w-full justify-center mt-8">
                <font-awesome-icon :icon="['fa', 'home']" class="h-3.5 w-3.5"/>
                Retour au tableau de bord
            </router-link>

            <button
                class="mt-4 text-sm font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-500 dark:hover:text-indigo-300"
                @click="$router.back()"
            >
                Page précédente
            </button>
        </div>
    </div>
</template>
